/* eslint-disable no-console */
/**
 * Alert service must be initialized before use
 * Web initialization: useWebInitAlert() in ./packages/web/src/services/alert/index.ts
 * Mobile initialization: useMobileInitAlert() in ./packages/mobileapp/src/services/alert/index.ts
 */

import Service from 'react-reservice';

import { IAlertHandler, IAlertHandlerProps } from './types';

interface IAlertContext {
  alertHandler: IAlertHandler | null;
}

class AlertService extends Service<IAlertContext> {
  constructor() {
    super();
    this.context = {
      alertHandler: null
    };
  }

  public setAlertHandler(alertHandler: IAlertHandler) {
    this.context = {
      ...this.context,
      alertHandler
    };
  }

  public showAlert(params: IAlertHandlerProps) {
    if (!this.context.alertHandler) {
      console.warn('AlertHandler must be set before showing alert');
      return;
    }
    this.context?.alertHandler?.alert(params);
  }
}

const alertService = new AlertService();
export default alertService;
